/**
 * Local-day labels for the thread. `now` is injectable so tests do not
 * depend on the clock. "Today" follows the viewer's timezone.
 */

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function timeOf(value) {
  const t = new Date(value).getTime();
  return Number.isNaN(t) ? null : t;
}

function startOfLocalDay(ms) {
  const date = new Date(ms);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

/** @param {unknown} value @param {number} [now] */
export function dayHeading(value, now = Date.now()) {
  const t = timeOf(value);
  if (t == null) return '';
  const day = startOfLocalDay(t);
  const today = startOfLocalDay(now);
  if (day === today) return 'Today';
  if (day === today - 86400000) return 'Yesterday';
  const date = new Date(t);
  const year = date.getFullYear() === new Date(now).getFullYear() ? '' : ` ${date.getFullYear()}`;
  return `${date.getDate()} ${MONTHS[date.getMonth()]}${year}`;
}

/** @param {unknown} value @param {number} [now] */
export function messageWhen(value, now = Date.now()) {
  const t = timeOf(value);
  if (t == null) return '';
  const heading = dayHeading(value, now);
  if (heading !== 'Today') return heading;
  const mins = Math.round((now - t) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return mins === 1 ? '1 min ago' : `${mins} min ago`;
  const hours = Math.round(mins / 60);
  return hours === 1 ? '1 hour ago' : `${hours} hours ago`;
}

/**
 * Oldest-first messages, one group per local day.
 * @param {Array<{ created_at?: string }>} messages
 * @param {number} [now]
 */
export function groupByDay(messages, now = Date.now()) {
  const groups = [];
  for (const message of messages || []) {
    const day = dayHeading(message.created_at, now) || 'Earlier';
    const last = groups[groups.length - 1];
    if (!last || last.day !== day) groups.push({ day, messages: [message] });
    else last.messages.push(message);
  }
  return groups;
}
